import { render, staticRenderFns } from "./WeekChooser.vue?vue&type=template&id=4fef5ee2&scoped=true"
import script from "./WeekChooser.vue?vue&type=script&lang=js"
export * from "./WeekChooser.vue?vue&type=script&lang=js"
import style0 from "./WeekChooser.vue?vue&type=style&index=0&id=4fef5ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fef5ee2",
  null
  
)

export default component.exports